import './ZoomController.less';
import React, {useState, useEffect} from 'react';
import Icon from "../../../components/icon/Icon";


export default function ZoomController({defaultValue = 1, min = 1, max = 2, step = 0.05, onChange = zoomScale => {}}) {

    const [zoomScale, setZoomScale] = useState(defaultValue);

    useEffect(() => {
        onChange(zoomScale);
    }, [zoomScale]);

    return <div className="zoom-controller">
        <button
            type="button"
            className="zoom-in-button"
            onClick={() => setZoomScale(s => Math.min(max, s + step))}
        >
            <Icon name="plus"/>
        </button>

        <input
            type="range"
            step={step}
            min={min}
            max={max}
            value={zoomScale}
            onChange={ev => setZoomScale(Number(ev.target.value))}
        />

        <button
            type="button"
            className="zoom-out-button"
            onClick={() => setZoomScale(s => Math.max(min, s - step))}
        >
            <Icon name="minus"/>
        </button>

    </div>;
}
